import { IconCollection } from "components/Icon/IconCollection";
import { resourceByName, resources } from "config";
import { FeExecutionType, FeRecordType } from "config/config";
import { MdiReactIconComponentType } from "mdi-react";

export const getTypeToIconMap = () => {
    const map = new Map();
    resources.forEach((resource) => {
        if (resource == null) return; // webpack (?) when hot reloading sometimes seems to cause this to be undefined, so we add this check here
        map.set(resource.resourceName, resource.icon);
    });
    return map;
};

export const getByRecordTypeName = (typeName: FeRecordType) => {
    return getTypeToIconMap().get(typeName.toLowerCase()); // TODO (low) remove unnecessary lowercasing once dependents typified
};

export const getByExecutionTypeName = (executionTypeName: FeExecutionType) => {
    const type = executionTypeName.toLowerCase();
    if (type === "flow") {
        return resourceByName.flow.icon;
    } else if (type === "script") {
        return resourceByName.flow.icon;
    } else if (type === "wrapper") {
        return resourceByName.wrapper.icon;
    } else if (type.startsWith("connect")) {
        return resourceByName.connector.icon;
    }
};

export type IconLike = React.ComponentType<{ className: string }> | MdiReactIconComponentType;

export interface IconProps {
    icon?: IconLike;
    byType?: FeRecordType;
    byName?: string;
    className?: string;
}

export const Icon = ({ icon, byType, byName, className }: IconProps) => {
    if (!icon && !byType && !byName) {
        console.error("parameters do not specify an icon");
        return <></>;
    }

    if (byType && !icon) {
        icon = getByRecordTypeName(byType);
        if (icon === undefined) {
            console.error("could not find icon by type ", byType);
            return <></>;
        }
    }

    if (byName && !icon) {
        icon = IconCollection?.[byName];
        if (icon === undefined) {
            console.error("could not find icon by name ", byName);
            return <></>;
        }
    }

    if (icon) {
        const IconComponent = icon;
        return <IconComponent className={`${className} icon`} />;
    }

    return <></>;
};
